import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=22479cae"
import script from "./PriceLists.vue?vue&type=script&lang=js"
export * from "./PriceLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports